<template>
  <div v-bind="inputAttrs">
    <v-autocomplete
      :items="filteredItems"
      :input-attrs="{ class: 'form-control', placeholder, id, autocomplete: 'off', ...inputAttrs }"
      :get-label="getLabel" 
      :component-item="template"
      :min-len="0"
      @change="changed"
      @update-items="update"
      @item-selected="selected"
      :wait="100"
      :auto-select-one-item="false" 
    />
  </div>
</template>

<script>
  import Vue from 'vue';
  import { defaults, VueDataTablesFiltersMixin } from 'vue-datatables.net';
  import ItemTemplate from './ItemTemplate';

  export default Vue.extend({
    mixins: [VueDataTablesFiltersMixin],

    data() {
      return {
        template: ItemTemplate
      }
    },
    props: {
      inputAttrs: {
        type: Object,
        default: () => {}
      },
      inputListeners: {
        type: Object,
        default: () => {}
      },
      placeholder: {
        type: String,
        default: defaults.dtOptions.language.searchPlaceholder
      },
      debounce: {
        type: Number,
        default: 10
      },
      size: {
        type: String
      },
      id: {
        type: String
      },
      autoApply: {
        type: Boolean,
        default: false
      },
      items: {
        type: Array
      }
    },
    methods: {
      getLabel(item) {
        return item.text;
      },
      update(text) {
        this.query = text;
        this.$emit('selected', null);
      },
      changed(value) {
        return this.inputListeners?.input ? 
          this.inputListeners.input(value) : 
          () => {};
      },
      selected(item) {
        this.update(item.value);
        this.$emit('selected', item);

        if (this.inputListeners?.input) {
          this.inputListeners.input(item.value);
        }
      }
    },
    computed: {
      filteredItems() {
        return this.items.filter((item) => {
          return (new RegExp((this.query || '').toLowerCase())).test(item.text.toLowerCase())
        });
      }
    }
  })
</script>